import FormField from 'components/community/common/FormField';
import React from 'react';
import { CHAR_LIMIT_MAP } from '../../CreateAirmeetV2/validations';

export const Name = ({
    formData,
    mode,
    errors,
    newOnBoardingFlow = false,
    pageMode = false,
    onEventNameFocus = () => {},
    isCreateAirmeetV3,
}) => (
    <FormField
        id={'name'}
        name={'name'}
        label={`Event name${isCreateAirmeetV3 ? '*' : ''}`}
        placeholder={
            isCreateAirmeetV3
                ? 'Give your event an exciting name'
                : newOnBoardingFlow
                ? 'Event name'
                : `John's new ${mode}`
        }
        filledValue={formData.name}
        isError={errors.name}
        errorMsg={errors.name}
        maxLength={CHAR_LIMIT_MAP['name'].max}
        variant={'v2'}
        subLabel={
            isCreateAirmeetV3
                ? null
                : newOnBoardingFlow
                ? pageMode
                    ? ''
                    : 'Name your exciting new event'
                : 'Give an exciting name to your upcoming event'
        }
        newOnBoardingFlow={newOnBoardingFlow}
        inputValue={pageMode ? formData?.name : null}
        value={formData?.name}
        onFocus={onEventNameFocus}
    />
);
